import { Box, BoxProps, PageGridContainer, Text } from "@govlaunch/web";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { createRef, forwardRef, ReactNode, useEffect } from "react";
import { useSelfie } from "~/components/auth/Auth";
import { useIntl } from "react-intl";

export default function HomepageNavigation() {
  const router = useRouter();
  const tabsRef = createRef<HTMLInputElement>();
  const viewer = useSelfie();
  const intl = useIntl();
  const pathname = router?.pathname;

  useEffect(() => {
    if (!tabsRef.current) {
      return;
    }

    if (pathname === "/vendors") {
      tabsRef.current.scrollLeft = 200;
    }
  }, []);

  return (
    <>
      <Box overflow="hidden">
        <Box
          display={["flex", "flex", "none"]}
          overflowX={["scroll", "scroll", "auto"]}
          ref={tabsRef}
          alignItems="center"
          justifyContent="space-between"
          bg="white"
          mb={2}
          px={2}
        >
          <Link href="/collections" passHref={true}>
            <MobileNavigationItem
              icon={
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  css={{ marginLeft: 4 }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.30769 0C1.67521 0 1.07368 0.2244 0.649038 0.649038C0.2244 1.07368 0 1.67521 0 2.30769V5.38462V8.46154V17.6923C0 18.3248 0.2244 18.9263 0.649038 19.351C1.07368 19.7756 1.67521 20 2.30769 20H5H17.6923H18C19.1046 20 20 19.1046 20 18V17.6923V9.23077V8.46154V8V6.92308V5.38462C20 4.75214 19.7756 4.1506 19.351 3.72596C18.9263 3.30132 18.3248 3.07692 17.6923 3.07692H9.23077V2.30769C9.23077 1.67521 9.00637 1.07368 8.58173 0.649038C8.15709 0.2244 7.55556 0 6.92308 0H2.30769ZM18 6C18.1589 6 18.3134 6.01852 18.4615 6.05352V5.38462C18.4615 5.09402 18.377 4.92752 18.2632 4.8137C18.1494 4.69988 17.9829 4.61538 17.6923 4.61538H9.23077C8.82906 4.61538 8.41803 4.46971 8.12801 4.17969C7.83798 3.88966 7.69231 3.47863 7.69231 3.07692V2.30769C7.69231 2.01709 7.60781 1.8506 7.49399 1.73678C7.38017 1.62296 7.21368 1.53846 6.92308 1.53846H2.30769C2.01709 1.53846 1.8506 1.62296 1.73678 1.73678C1.62296 1.8506 1.53846 2.01709 1.53846 2.30769V5.38462V8.46154V17.6923C1.53846 17.9829 1.62296 18.1494 1.73678 18.2632C1.8506 18.377 2.01709 18.4615 2.30769 18.4615C2.59829 18.4615 2.76478 18.377 2.87861 18.2632C2.92616 18.2157 2.9686 18.1589 3.00189 18.0878C3.00064 18.0587 3 18.0294 3 18V8C3 6.89543 3.89543 6 5 6H18ZM12.9548 11.4977L11.5 9L10.0452 11.4977L7.22025 12.1094L9.14614 14.2648L8.85497 17.1406L11.5 15.975L14.145 17.1406L13.8539 14.2648L15.7798 12.1094L12.9548 11.4977Z"
                    fill="currentColor"
                  />
                </svg>
              }
              label={intl.formatMessage({
                defaultMessage: "Collections",
                id: "ulh3kf",
              })}
              active={pathname === "/" || pathname === "/collections"}
            />
          </Link>
          <Link href="/governments" passHref={true}>
            <MobileNavigationItem
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20.7778 19.0006H19.5556V10.445H20.7778C21.3046 10.445 21.7702 10.1089 21.9364 9.60902C22.1039 9.11035 21.9316 8.56035 21.5099 8.24502L11.7321 0.911682C11.2982 0.584127 10.7006 0.584127 10.2667 0.911682L0.488889 8.24502C0.0684444 8.56035 -0.103889 9.11035 0.0635556 9.60902C0.229778 10.1089 0.695444 10.445 1.22222 10.445H2.44444V19.0006H1.22222C0.546333 19.0006 0 19.5469 0 20.2228C0 20.8987 0.546333 21.445 1.22222 21.445H20.7778C21.4537 21.445 22 20.8987 22 20.2228C22 19.5469 21.4537 19.0006 20.7778 19.0006ZM11 3.41724L17.1111 8.00057H4.88889L11 3.41724ZM4.88889 19.0006V10.445H7.33333V19.0006H4.88889ZM9.77778 19.0006V10.445H12.2222V19.0006H9.77778ZM14.6667 19.0006V10.445H17.1111V19.0006H14.6667Z"
                    fill="currentColor"
                  />
                </svg>
              }
              label={intl.formatMessage({
                defaultMessage: "Governments",
                id: "qnQX9U",
              })}
              active={pathname === "/governments"}
            />
          </Link>
          <Link href="/vendors" passHref={true}>
            <MobileNavigationItem
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12.9127 17.88V19.8175H11.0476V18.0138C9.7381 17.9565 8.51409 17.6123 7.78746 17.1916L8.35639 14.9543C9.15952 15.3942 10.2854 15.7957 11.5283 15.7957C12.6183 15.7957 13.3629 15.375 13.3629 14.6102C13.3629 13.8835 12.7504 13.4246 11.3353 12.9465C9.28925 12.2581 7.89436 11.3021 7.89436 9.44722C7.89436 7.76448 9.06349 6.44508 11.127 6.04353V4.22222H12.9921V5.90968C14.2619 5.96706 15.1368 6.23476 15.7679 6.54071L15.2149 8.70151C14.7177 8.49115 13.8389 8.05135 12.4621 8.05135C11.2192 8.05135 10.818 8.58679 10.818 9.12218C10.818 9.75321 11.4875 10.1548 13.1128 10.7667C15.3883 11.5698 16.3113 12.6215 16.3113 14.3424C16.3113 16.0443 15.0952 17.4976 12.9127 17.88Z"
                    fill="currentColor"
                  />
                </svg>
              }
              label={intl.formatMessage({
                id: "RilevA",
                defaultMessage: "Vendors",
              })}
              active={pathname === "/vendors"}
            />
          </Link>
        </Box>
      </Box>

      <PageGridContainer>
        <Box display={["none", "none", "flex"]} justifyContent="flex-start" alignItems="center" mb={8} width="100%">
          <NavigationItem
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.30769 0C1.67521 0 1.07368 0.2244 0.649038 0.649038C0.2244 1.07368 0 1.67521 0 2.30769V5.38462V8.46154V17.6923C0 18.3248 0.2244 18.9263 0.649038 19.351C1.07368 19.7756 1.67521 20 2.30769 20H5H17.6923H18C19.1046 20 20 19.1046 20 18V17.6923V9.23077V8.46154V8V6.92308V5.38462C20 4.75214 19.7756 4.1506 19.351 3.72596C18.9263 3.30132 18.3248 3.07692 17.6923 3.07692H9.23077V2.30769C9.23077 1.67521 9.00637 1.07368 8.58173 0.649038C8.15709 0.2244 7.55556 0 6.92308 0H2.30769ZM18 6C18.1589 6 18.3134 6.01852 18.4615 6.05352V5.38462C18.4615 5.09402 18.377 4.92752 18.2632 4.8137C18.1494 4.69988 17.9829 4.61538 17.6923 4.61538H9.23077C8.82906 4.61538 8.41803 4.46971 8.12801 4.17969C7.83798 3.88966 7.69231 3.47863 7.69231 3.07692V2.30769C7.69231 2.01709 7.60781 1.8506 7.49399 1.73678C7.38017 1.62296 7.21368 1.53846 6.92308 1.53846H2.30769C2.01709 1.53846 1.8506 1.62296 1.73678 1.73678C1.62296 1.8506 1.53846 2.01709 1.53846 2.30769V5.38462V8.46154V17.6923C1.53846 17.9829 1.62296 18.1494 1.73678 18.2632C1.8506 18.377 2.01709 18.4615 2.30769 18.4615C2.59829 18.4615 2.76478 18.377 2.87861 18.2632C2.92616 18.2157 2.9686 18.1589 3.00189 18.0878C3.00064 18.0587 3 18.0294 3 18V8C3 6.89543 3.89543 6 5 6H18ZM12.9548 11.4977L11.5 9L10.0452 11.4977L7.22025 12.1094L9.14614 14.2648L8.85497 17.1406L11.5 15.975L14.145 17.1406L13.8539 14.2648L15.7798 12.1094L12.9548 11.4977Z"
                  fill="currentColor"
                />
              </svg>
            }
            label={intl.formatMessage({
              defaultMessage: "Collections",
              id: "ulh3kf",
            })}
            href={viewer ? "/" : "/collections"}
            active={pathname === "/" || pathname === "/collections"}
          />
          <NavigationItem
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.7778 19.0006H19.5556V10.445H20.7778C21.3046 10.445 21.7702 10.1089 21.9364 9.60902C22.1039 9.11035 21.9316 8.56035 21.5099 8.24502L11.7321 0.911682C11.2982 0.584127 10.7006 0.584127 10.2667 0.911682L0.488889 8.24502C0.0684444 8.56035 -0.103889 9.11035 0.0635556 9.60902C0.229778 10.1089 0.695444 10.445 1.22222 10.445H2.44444V19.0006H1.22222C0.546333 19.0006 0 19.5469 0 20.2228C0 20.8987 0.546333 21.445 1.22222 21.445H20.7778C21.4537 21.445 22 20.8987 22 20.2228C22 19.5469 21.4537 19.0006 20.7778 19.0006ZM11 3.41724L17.1111 8.00057H4.88889L11 3.41724ZM4.88889 19.0006V10.445H7.33333V19.0006H4.88889ZM9.77778 19.0006V10.445H12.2222V19.0006H9.77778ZM14.6667 19.0006V10.445H17.1111V19.0006H14.6667Z"
                  fill="currentColor"
                />
              </svg>
            }
            label={intl.formatMessage({
              defaultMessage: "Governments",
              id: "qnQX9U",
            })}
            href="/governments"
            active={pathname === "/governments"}
          />
          <NavigationItem
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12.9127 17.88V19.8175H11.0476V18.0138C9.7381 17.9565 8.51409 17.6123 7.78746 17.1916L8.35639 14.9543C9.15952 15.3942 10.2854 15.7957 11.5283 15.7957C12.6183 15.7957 13.3629 15.375 13.3629 14.6102C13.3629 13.8835 12.7504 13.4246 11.3353 12.9465C9.28925 12.2581 7.89436 11.3021 7.89436 9.44722C7.89436 7.76448 9.06349 6.44508 11.127 6.04353V4.22222H12.9921V5.90968C14.2619 5.96706 15.1368 6.23476 15.7679 6.54071L15.2149 8.70151C14.7177 8.49115 13.8389 8.05135 12.4621 8.05135C11.2192 8.05135 10.818 8.58679 10.818 9.12218C10.818 9.75321 11.4875 10.1548 13.1128 10.7667C15.3883 11.5698 16.3113 12.6215 16.3113 14.3424C16.3113 16.0443 15.0952 17.4976 12.9127 17.88Z"
                  fill="currentColor"
                />
              </svg>
            }
            label={intl.formatMessage({
              id: "RilevA",
              defaultMessage: "Vendors",
            })}
            href="/vendors"
            active={pathname === "/vendors"}
          />
        </Box>
      </PageGridContainer>
    </>
  );
}

interface INavigationITemProps {
  icon: ReactNode;
  label: string;
  href: string;
  active?: boolean;
}

function NavigationItem({ icon, label, href, active }: INavigationITemProps) {
  return (
    <Link href={href} passHref={true}>
      <Box as="a" display="flex" alignItems="center" mr={6} color={active ? "blue.600" : "gray.800"} mt={[4, 4, 0]}>
        {icon}
        <Text fontSize="md" fontWeight="semibold" ml={2} as={active ? "h1" : "p"}>
          {label}
        </Text>
      </Box>
    </Link>
  );
}

interface IMobileNavigationItem extends BoxProps {
  icon: ReactNode;
  label: string;
  active: boolean;
  slug?: string;
  tab?: string;
}

const MobileNavigationItem = forwardRef<any, IMobileNavigationItem>(({ icon, label, active, ...props }, ref) => {
  return (
    <Box
      as="a"
      color={active ? "blue.600" : "gray.800"}
      display="flex"
      flexDirection={["column", "column", "row"]}
      alignItems="center"
      justifyContent="center"
      width="100%"
      minHeight="72px"
      borderTop="1px"
      borderTopWidth="5px"
      py={2}
      px={["8px", "8px", "24px"]}
      borderColor={active ? "blue.600" : "transparent"}
      ref={ref}
      _hover={{
        bg: "blue.50",
      }}
      {...props}
    >
      {icon}

      <Text fontWeight="semibold" fontSize={["md", "md", "lg"]} whiteSpace="nowrap" mt={1}>
        {label}
      </Text>
    </Box>
  );
});

MobileNavigationItem.displayName = "MobileNavigationItem";
